export * from './api'

/** JSON-LD breadcrumb·canonical·OG에 쓰는 절대 URL이라 basePath(/v2)를 포함한다 */
export const MYCLE_HOME_URL = 'https://service.mycle.co.kr/v2'
export const MODOOCAR_BASE_URL = `${MYCLE_HOME_URL}/modoocar`

/** next/link·라우터가 basePath를 붙이므로 포함하지 않는다 */
export const MODOOCAR_RANK_ROUTE = '/modoocar/rank'
